import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { search, cart, person, homeSharp } from 'ionicons/icons';
import { StateService } from 'src/app/services/state.service';
import { DownloadAppComponent } from "./download-app/download-app.component";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [IonIcon, RouterModule, DownloadAppComponent],
})
export class SidebarComponent {
  private $state = inject(StateService);

  private orders = toSignal(this.$state.bOrders);

  public activeOrderCount = computed<number>(() => this.orders()?.filter(order => !['Cancelled', 'Completed', 'Delivered'].includes(order.status!)).length ?? 0);

  constructor() {
    addIcons({ homeSharp, search, cart, person });
  }

}
